import { render, staticRenderFns } from "./UserExercisesResponses.vue?vue&type=template&id=29211bbe&"
import script from "./UserExercisesResponses.vue?vue&type=script&lang=js&"
export * from "./UserExercisesResponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports